import { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";

import CustomButton from "../../components/CustomButton";
import ContentCard from "../../components/misc/ContentCard";

import { fetchGetClientsNodes } from "../../redux/api/expedition.api";
import { clearWorkingRoutesNodes } from "../../redux/reducer/expedition.reducer";
import AwbHistoryTable from "./AwbHistoryTable";
import {
  clearAwbHistory,
  clearBinHistory,
} from "../../redux/reducer/general.reducer";
import BinHistoryTable from "./BinHistoryTable";

function Home() {
  const dispatch = useAppDispatch();

  const [selectedType, setSelectedType] = useState<"awb" | "bin">("awb");

  useEffect(() => {
    dispatch(
      fetchGetClientsNodes({
        page: 1,
        perPage: 50,
      }),
    );

    return () => {
      dispatch(clearWorkingRoutesNodes());
      dispatch(clearAwbHistory());
      dispatch(clearBinHistory());
    };
  }, [dispatch]);

  return (
    <>
      <ContentCard cardBodyClassName="flex">
        <CustomButton
          variant={selectedType === "awb" ? "contained" : "outlined"}
          style={{ borderEndEndRadius: 0, borderStartEndRadius: 0 }}
          fullWidth
          onClick={() => setSelectedType("awb")}>
          Expeditie colete
        </CustomButton>
        <CustomButton
          variant={selectedType === "bin" ? "contained" : "outlined"}
          style={{ borderEndStartRadius: 0, borderStartStartRadius: 0 }}
          fullWidth
          onClick={() => setSelectedType("bin")}>
          Expeditie BIN
        </CustomButton>
      </ContentCard>
      {selectedType === "awb" && <AwbHistoryTable />}

      {selectedType === "bin" && <BinHistoryTable />}
    </>
  );
}

export default Home;
